import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { LOGO_URL } from "./AdminLogin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | done | error

  useEffect(() => {
    axios
      .post(`${API}/newsletter/unsubscribe/${token}`)
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center px-6 py-16 text-center">
      <img src={LOGO_URL} alt="INN.PACT" className="h-16 object-contain mb-10" />
      <div className="w-full max-w-lg bg-white border border-black/5 p-10">
        {state === "loading" && <p className="label-editorial text-black/40">A processar…</p>}
        {state === "done" && (
          <>
            <p className="label-editorial text-black/50 mb-3">Newsletter</p>
            <h1 className="font-display text-3xl tracking-tight">Subscrição cancelada</h1>
            <p className="mt-4 text-black/50 font-light">
              Deixou de receber a nossa newsletter. Pode voltar a subscrever a qualquer momento.
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="font-display text-3xl tracking-tight">Ligação inválida</h1>
            <p className="mt-4 text-black/50 font-light">Esta ligação de cancelamento não é válida ou já foi usada.</p>
          </>
        )}
      </div>
      <a href="/" className="mt-8 label-editorial text-black/40 hover:text-black">Voltar ao site</a>
    </div>
  );
}
